<template>
    <div :style="style" class="all">
        <div class="head">
            <span v-html="$getConfigText(block.inner.title)"></span>
        </div>
        <div class="foot">
            <button 
                v-show="block.btnForm.status"
                v-html="$getConfigText(block.btnForm.buttonText)"
                :style="btnStyle"
                @click="goLink"></button>
        </div>
    </div>
</template>

<style lang='scss' scoped>
    .all{
        display: flex;
        flex-direction: column;
        align-items: center;
        min-height: 5.65rem;
        background: #3E97F0;
        .head{
            margin-top: 1.33rem;
            margin-bottom: 0.96rem;
            color:#fff;
            font-size: 0.59rem;
            line-height: 0.8rem;
            font-weight: bold;
            span{
                text-align: center;
            }
        }
        .foot{
            button{  
                width: 3.41rem;
                height: 1.23rem;
                margin-bottom: 0.96rem;
                line-height: 1.4;
                background: #3E97F0;
                border:1px solid #fff;
                border-radius: 0.27rem;
                font-size: 0.43rem;
                font-weight: bold;
                color:#fff;
            }
        }
    }
</style>

<script>
export default {
    name:'TitleBtn',
    props:{
        block:Object,
    },
    computed:{
        style(){
            return `background-color:${this.block.backColor};
                    color:${this.block.fontColor}`
        },
        btnStyle(){
            return `background-color:${this.block.btnForm.buttonColor};
                    color:${this.block.btnForm.buttonTextColor}`
        }
    },
    methods: {
        goLink(){
            window.open(this.block.btnForm.buttonJumpUrl)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/templates/m-blocks/title-btn.vue